import { createVNode as _createVNode } from "vue";
/**
 * @author yili
 * @fileoverview 赛事说明 - 路由页面
 */

import { defineComponent } from "vue";
// components
import PcBox from "@/components/pc/race-info.vue";
import MBox from "@/components/m/race-info.vue";
export default defineComponent({
  name: "RaceInfo",
  props: {
    // 是否是被其它组件引入
    referType: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    return () => {
      return window.screen.width < 1200 ? _createVNode(MBox, {
        "referType": props.referType
      }, null) : _createVNode(PcBox, {
        "referType": props.referType
      }, null);
    };
  }
});